import { Badge } from '../../../ui';

/** Selos da origem da fatura: veio do Open Finance e, se for o caso, foi montada por estimativa. */
export function FaturaOrigemBadges({
  invoice,
}: {
  invoice: { sourceFormat?: 'UPLOAD' | 'OPEN_FINANCE'; estimated?: boolean };
}) {
  if (invoice.sourceFormat !== 'OPEN_FINANCE' && !invoice.estimated) {
    return null;
  }
  return (
    <span className="inline-flex gap-1">
      {invoice.sourceFormat === 'OPEN_FINANCE' && <Badge tone="info">Open Finance</Badge>}
      {invoice.estimated && (
        <Badge
          tone="warning"
          title="Itens pelo ciclo ou com item de fora: confira com o total do banco"
        >
          estimada
        </Badge>
      )}
    </span>
  );
}
